// extracted by mini-css-extract-plugin
export var approvals = "academy-module--approvals--71135";
export var approved = "academy-module--approved--758ef";
export var benefitsCards = "academy-module--benefits-cards--4ed68";
export var benefitsCardsImage = "academy-module--benefits-cards-image--e82bd";
export var benefitsCardsTitle = "academy-module--benefits-cards-title--64728";
export var benefitsList = "academy-module--benefits-list--3a346";
export var btnAcademyLogin = "academy-module--btn-academy-login--3f9d7";
export var btnMenuFilter = "academy-module--btn-menu-filter--ff319";
export var btnMenuFilterActive = "academy-module--btn-menu-filter-active--e12a8";
export var btnPricing = "academy-module--btn-pricing--648da";
export var btnPricingEnd = "academy-module--btn-pricing-end--da515";
export var btnPricingTagline = "academy-module--btn-pricing-tagline--62f8e";
export var catalogHeading = "academy-module--catalog-heading--f829f";
export var catalogImage = "academy-module--catalog-image--988fc";
export var courseCard = "academy-module--course-card--7e680";
export var courseCardImage = "academy-module--course-card-image--31251";
export var courseInfo = "academy-module--course-info--c7fdf";
export var courseText = "academy-module--course-text--8e1e4";
export var form = "academy-module--form--7ea5d";
export var h1 = "academy-module--h1--a68f1";
export var menuFilter = "academy-module--menu-filter--7295e";
export var notApproved = "academy-module--not-approved--c1b51";
export var pending = "academy-module--pending--8f66b";
export var pricingBorder = "academy-module--pricing-border--63ac8";
export var pricingTitle = "academy-module--pricing-title--ccacb";
export var quotes = "academy-module--quotes--8bf53";
export var quotesDescription = "academy-module--quotes-description--c8818";
export var quotesImage = "academy-module--quotes-image--c5947";
export var sectionBackground = "academy-module--section-background--d7ecc";
export var sectionPadding = "academy-module--section-padding--6649e";
export var showFormStepper = "academy-module--show-form-stepper--cb1b2";
export var sidebar = "academy-module--sidebar--fb0a8";
export var stateForm = "academy-module--state-form--8d17d";